"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUsage = exports.getSummary = void 0;

const utils_1 = require("../utils");

const getSummary = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/consumables:summary`;
  const params = utils_1.omitIfNil({
    contract_id: options.contractId,
    delegation_type: options.delegationType,
    fulfillment_id: options.fulfillmentId,
    group_id: options.groupId,
    include_depleted: options.includeDepleted,
    include_expired: options.includeExpired,
    include_usage: options.includeUsage,
    include_usage_limit: options.includeUsageLimit,
    license_id: options.licenseId,
    page: options.pageNumber,
    page_size: options.pageSize,
    sort: options.sortExpression,
    sort_order: options.sortOrder,
    summarize_by: options.summarizeBy
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getSummary = getSummary;

const getUsage = (jilFetch, options) => {
  const path = `organizations/${options.orgId}/consumables:usages`;
  const params = utils_1.omitIfNil({
    contract_id: options.contractId,
    delegation_type: options.delegationType,
    fulfillable_item_code: options.fulfillableItemCode,
    fulfillment_id: options.fulfillmentId,
    group_id: options.groupId,
    include_depleted: options.includeDepleted,
    include_expired: options.includeExpired,
    license_id: options.licenseId,
    page: options.pageNumber,
    page_size: options.pageSize,
    sort: options.sortExpression,
    sort_order: options.sortOrder
  });
  return jilFetch(path, params, {
    method: 'GET'
  });
};

exports.getUsage = getUsage;